module.exports = __webpack_public_path__ + "img/Lev Icon - white.1b624ee0.svg";